<script setup lang="ts">
import { useConfigStore } from '@core/stores/config'
import OurTeam from '@/views/front-pages/landing-page/our-team.vue'

const store = useConfigStore()

store.skin = 'default'

definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Ons Team',
    subtitle: 'maak kennis met onze fantastische monitoren',
    icon: 'bx-group',
    iconColor: 'primary',
  },
})

useSeoMeta({
  title: 'Ons Team - Maak Kennis met Onze Monitoren',
  description:
    'Maak kennis met onze fantastische monitoren bij \'t SpeelFabrik. Ontmoet het enthousiaste team dat zorgt voor een onvergetelijke kampervaring.',
  ogTitle: 'Ons Team - \'t SpeelFabrik',
  ogDescription: 'Maak kennis met onze fantastische monitoren bij \'t SpeelFabrik.',
  ogType: 'website',
  ogUrl: 'https://www.tspeelfabrik.be/ons-team',
  ogImage: 'https://www.tspeelfabrik.be/images/og-team.jpg',
  robots: 'index, follow',
})

// Branded OG image
defineOgImage('SpeelFabrik', {
  title: 'Ons Team',
  description: 'Maak kennis met onze fantastische monitoren.',
})

useHead({
  meta: [
    { name: 'keywords', content: 'monitoren, team, begeleiders, SpeelFabrik, jeugdmonitoren, kampbegeleiders' },
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.tspeelfabrik.be/ons-team',
    },
  ],
})
</script>

<template>
  <div class="landing-page-wrapper">
    <!-- 👉 Our Team Section -->
    <div :style="{ 'background-color': 'rgb(var(--v-theme-surface))' }">
      <OurTeam />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.landing-page-wrapper {
  background-color: rgb(var(--v-theme-surface));
}
</style>
